import * as React from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import s from './button.scss';
import {showSubscriptionOverlay} from '../../actions';
import {State} from '../../reducers';

export interface ButtonProps extends WithTranslation {
  showSubscriptionOverlay: () => void;
  enabled: boolean;
}

export class ButtonCmp extends React.PureComponent<ButtonProps> {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick () {
    this.props.showSubscriptionOverlay();
  }
  render() {
    const {t, enabled} = this.props;
    if (!enabled) {
      return null;
    }
    return (
      <button className={s.button} data-hooks="show-overlay" onClick={this.handleClick}>{t('subscription.global.button')}</button>
    );
  }
}

function mapStateToProps(state: State) {
  return {
    enabled: state.user.isLoggedIn && state.subscriptions.subscribed === false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showSubscriptionOverlay: () => dispatch(showSubscriptionOverlay()),
  };
}

export const Button: any = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ButtonCmp));
